import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { TrustBar } from './components/TrustBar';
import { SolutionSection } from './components/SolutionSection';
import { HowItWorks } from './components/HowItWorks';
import { ProductShowcase } from './components/ProductShowcase';
import { WhoItsFor } from './components/WhoItsFor';
import { PayerCoverage } from './components/PayerCoverage';
import { BenefitsSection } from './components/BenefitsSection';
import { PricingPreview } from './components/PricingPreview';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans selection:bg-brand-teal/20 selection:text-brand-dark" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustBar data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <ProductShowcase data-id="element-7" />
        <WhoItsFor data-id="element-8" />
        <PayerCoverage data-id="element-9" />
        <PricingPreview data-id="element-10" />
        <BenefitsSection data-id="element-11" />
        <FAQSection data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>

      <Footer data-id="element-14" />

      {/* Mobile Sticky CTA */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-slate-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50" data-id="element-15">
        <button className="flex justify-center items-center w-full py-3.5 px-4 border border-transparent rounded-lg shadow-sm text-base font-semibold text-white bg-brand-teal hover:bg-brand-dark transition-colors" data-id="element-16">
          Sign Up
        </button>
      </div>

      {/* Spacer for mobile sticky CTA */}
      <div className="h-20 md:hidden bg-[#1a202c]" data-id="element-17"></div>
    </div>;
}